// main
import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";

import WebbDividerMedium from "../webx/webb-divider-md"
import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbSpinner from "../webx/webb-spinner";
import WebbLoader from "../webx/webb-loader";
import WebbModuleInfo from "../webx/webb-module-info";


import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { MediaStatus, MediaEdit } from "../../services/srvc-media-realm";

import { Form, Input, InputNumber, Button, Result, Space, Select  } from 'antd';
const { TextArea } = Input;

export default function MediaEditModule () {
  
  const usxx = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();
  
  const {id} = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [submit, setSubmit] = useState(false);
  const [done, setDone] = useState(false);
  const [check, setCheck] = useState(true);

  
  const [info, setInfo] = useState();
  const [creators, setCreators] = useState();


  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);

        const media = await MediaStatus({
          data: {media: id},
          user: asset.usid
        })
        console.log(media)
        setInfo(media.data)

        // const creator = [...media.data.media.owner,...media.data.media.admin, ...media.data.media.team ]
        // setCreators(creator);

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  const onFinish = async (values) => {

    setSubmit(true)
    setLoading(true)
    
    const datx = {
      "name": values.name ??= '***',
      "memo": values.memo ??= '***',
      "rate": (values.rate).toString(),
      "media": id
    }
    console.log (datx)

    const result = await MediaEdit({data: datx, user: asset.usid})

    if (result.data) {
      setDone(true)
    }
    else {setDone(false)}
    setLoading(false)

  };
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  if (loading) return <WebbLoader />

  return (
  <>
    {/* info */}
    <div className={submit ? 'd-none' : ''}>
      <WebbModuleInfo data={{text:'Edit Details and Save'}} />
      <WebbDividerSmall />
    </div>

    {/* data */}
    <div className={submit ? 'd-none' : ''}>
      <Form
        name="data"
        layout="vertical"
        initialValues={{name: info.media.name, memo: info.media.memo, rate:info.media.rate }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >

      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please enter Media Name' }]}
      >
        <Input placeholder="Media Name" className="height-md rounded-wd"/>
      </Form.Item>

      <Form.Item
        label="Description"
        name="memo"
        rules={[{ required: true, message: 'Please enter description' }]}
      >
       <TextArea rows={3} placeholder="Media Description" className="rounded-wd" />
      </Form.Item>

      <Form.Item
        label="List Price"
        name="rate"
        rules={[{ required: true, message: 'Please enter list price' }]}
      >
        <Input placeholder="0.00" className="height-md rounded-wd"/>
      </Form.Item>


      <WebbDividerMedium />
      <WebbDividerMedium />

        <Form.Item wrapperCol={{}}>
          <Button 
            type="primary" htmlType="submit" 
            className="height-md rounded-wd back-color-next border-none" 
            disabled={!check}
            style={{width:'100%'}}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>


    {/* result */}
    <div className={submit ? 'back-color-wite text-center mb-3' : 'd-none'}>
      <WebbDividerSmall />
      
      <Result
        status="success"
        title="Congratulations!"
        subTitle="Your Media is Created."
        className={done ? '' : 'd-none'}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/mx/v/${id}`)}>
            Media
          </Button>,
          <Button key="reload" 
            className="rounded-wd d-none"
            onClick={()=> setSubmit(false)}>
          New Media</Button>,
        ]}
      />
      
      <Result
        status="warning"
        title="Error!"
        subTitle="Please try again."
        className={done ? 'd-none' : ''}
        extra={[
          <Button type="primary" key="home" 
            className="back-color-next border-none rounded-wd"
            onClick={()=>history.push(`/${usxx}/mx/v/${id}`)}>
            Media
          </Button>,
          <Button key="reload" 
            className="rounded-wd"
            onClick={()=> setSubmit(false)}>
          Try Again</Button>,
        ]}
      />

    </div>

  </>
  )
}